/* src/app/admin-dashboard/site-system/inventory/inventory.component.css */
/*# sourceMappingURL=inventory.component.css.map */
